import {useSelector} from 'react-redux';
import {useMemo} from 'react';
const filtered = ['sponsor','ref','ref_code','coupon','ref_code_and_coupon']

export default function usePendingRequiredFields(){
  const signup_data = useSelector((state)=>state.settings.signup_data);
  const profileFields = useSelector((state)=>state.settings.profileFields);
  const settings = useSelector((state)=>state.settings);
  return useMemo(()=>{
    const fields = profileFields ? JSON.parse(profileFields) : []
    const data = signup_data ? JSON.parse(signup_data) : {}
    return fields.filter(({id, isEnabled, isRequired})=>isEnabled && isRequired && (settings[id] === undefined || settings[id] === null) && data[id] === undefined && filtered.indexOf(id) < 0)
  },[profileFields, signup_data])
}
